import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'course_name', label: 'Course' },
  { key: 'institution', label: 'Institution' },
  { key: 'category', label: 'Category' },
  { key: 'date', label: 'Date' },
  { key: 'certificate', label: 'Certificate' },
];

export function TrainingRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Training Records Register"
      description="Every training record with institution, category, and certificate presence."
      endpoint="/reports/hr/training"
      columns={COLUMNS}
      filters={['category', 'dateRange']}
      categoryOptions={listOptions(lists, 'training_category')}
      listColumns={{ category: 'training_category' }}
    />
  );
}
